import { rgbToCss } from "core/color";
import { random } from "core/math";
import { dt } from "lib/loop";

const PARTICLE_DAMP = Math.pow(0.95, 30);

export interface Explosion {
  x: number;
  y: number;
  count: number;
  t: number;
  big: boolean;
}

export interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  color: string;
  size: number;
  big: boolean;
}

export const explosions: Explosion[] = [];
export const particles: Particle[] = [];

export function updateEffects(): void {
  for (let i = explosions.length - 1; i >= 0; i--) {
    const e = explosions[i];
    if (e.t === 0) {
      emitExplosion(e);
    }
    e.t++;
    if (e.t > 30) {
      explosions.splice(i, 1);
    }
  }

  for (let i = particles.length - 1; i >= 0; i--) {
    const p = particles[i];
    p.x += p.vx * dt;
    p.y += p.vy * dt;
    p.vx *= Math.pow(PARTICLE_DAMP, dt);
    p.vy *= Math.pow(PARTICLE_DAMP, dt);
    if (p.big) p.vy += 1.5 * dt;
    p.life -= dt * 30;
    if (p.life <= 0) {
      particles.splice(i, 1);
    }
  }
}

function emitExplosion(e: Explosion): void {
  const hue = (random() * 360) | 0;
  for (let i = 0; i < e.count; i++) {
    const angle = random() * Math.PI * 2;
    const dist = e.big ? 8 + random() * 24 : 15 + random() * 5;
    const life = e.big ? (12 + random() * 18) | 0 : (9 + random() * 6) | 0;
    particles.push({
      x: e.x,
      y: e.y,
      vx: Math.cos(angle) * dist * 3,
      vy: Math.sin(angle) * dist * 3,
      life,
      maxLife: life,
      color: `hsl(${hue}, 100%, 50%)`,
      size: e.big ? 2.5 : 1.5,
      big: e.big,
    });
  }
}

export function emitBlood(x: number, y: number): void {
  for (let i = 0; i < 10; i++) {
    const angle = random() * Math.PI * 2;
    const speed = 15 + random() * 45;
    const life = (8 + random() * 10) | 0;
    particles.push({
      x,
      y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed - 9,
      life,
      maxLife: life,
      color: rgbToCss(0xff0000),
      size: 1,
      big: true,
    });
  }
}

export function emitTrail(x: number, y: number, vx: number, color: string): void {
  const life = (3 + random() * 5) | 0;
  particles.push({
    x: x + (random() - 0.5) * 2,
    y: y + (random() - 0.5) * 2,
    vx: (random() - 0.5) * 9 + vx * 0.5,
    vy: (random() - 0.5) * 9,
    life,
    maxLife: life,
    color,
    size: 2,
    big: false,
  });
}

export function emitCoinCollect(x: number, y: number): void {
  for (let i = 0; i < 6; i++) {
    const angle = random() * Math.PI * 2;
    const speed = 9 + random() * 24;
    const life = (6 + random() * 8) | 0;
    particles.push({
      x,
      y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      life,
      maxLife: life,
      color: `hsl(${(45 + random() * 15) | 0}, 100%, 60%)`,
      size: 1.2,
      big: false,
    });
  }
}
